import Lara from '@primeuix/themes/lara'

// PrimeVue's theme, imported by the module (nuxt.config.ts `importTheme`) so
// the preset ships in the cached JS bundle. Set as `options.theme` it was
// copied into the public runtime config: 133 KB inside every page's HTML.
export default {
  preset: Lara,
  options: {
    darkModeSelector: '.dark',
    cssLayer: false,
  },
}
